import { AppraisalProductNode } from '../types/reggoraTypes';

export const filterAndSortAppraisalProducts = (appraisalProducts: AppraisalProductNode[]): AppraisalProductNode[] => {
  return (appraisalProducts || [])
    .filter(product => product.isUsedByHometap)
    .sort((a, b) => a.name.localeCompare(b.name));
};
